<template>
  <div>
    <div class="card-body">
      <div class="row">
        <div class="col-lg-4 col-md-4 col-sm-12">
          <div class="form-group">
            <label for="tipos_eventos">Eventos Correos</label>
            <v-select
              :class="$store.getters.getDarkMode ? 'dark-vselect' : ''"
              v-model="cor.eventos"
              :multiple="true"
              label="descripcion"
              :options="listasForms.eventos_correos"
              :reduce="e => e.numeracion"
              placeholder="Seleccione uno o varios eventos..."
              :close-on-select="false"
            ></v-select>
            <small class="text-muted">
              Puede seleccionar varios eventos a la vez
            </small>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12">
          <div class="form-group">
            <label for="correo">Emails</label>
            <v-select
              :class="$store.getters.getDarkMode ? 'dark-vselect' : ''"
              v-model="cor.correos"
              :multiple="true"
              :taggable="true"
              :no-drop="true"
              :create-option="email => email.trim().toLowerCase()"
              placeholder="Escriba un email y presione Enter..."
              :close-on-select="false"
              @option:created="validarEmailTag"
            ></v-select>
            <small class="text-muted">
              Escriba cada email y presione Enter para agregar varios
            </small>
          </div>
        </div>
        <div class="col-lg-2 col-md-2 col-sm-12">
          <div class="form-group">
            <label for="celular">Celular</label>
            <input
              type="number"
              class="form-control form-control-sm"
              id="celular"
              v-model="cor.celular"
            />
          </div>
        </div>
        <div class="col-lg-2 col-md-2 col-sm-12">
          <br />
          <button
            type="button"
            @click="guardar_correos()"
            class="btn btn-primary"
            :disabled="!formularioValido"
            v-show="$store.getters.can('admin.empresas.agregarCorreo')"
          >
            <i class="fa fa-plus-circle"></i> Agregar
            <span v-if="totalRegistros > 1" class="badge badge-light ml-1">
              {{ totalRegistros }}
            </span>
          </button>
        </div>
      </div>
      <div class="row" v-if="totalRegistros > 0">
        <div class="col-md-12">
          <small class="text-info">
            Se crearán <strong>{{ totalRegistros }}</strong> registro(s):
            {{ cor.eventos.length }} evento(s) × {{ cor.correos.length }} correo(s)
          </small>
        </div>
      </div>
      <hr />
      <div class="row">
        <div class="col-md-12">
          <table
            id="docs"
            class="table table-bordered table-striped table-hover table-sm table-head-fixed text-nowrap"
          >
            <thead>
              <tr>
                <th>Evento</th>
                <th>Correo</th>
                <th>Celular</th>
                <th>Opciones</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="data in correos" :key="data.id">
                <td v-text="data.nEvento"></td>
                <td v-text="data.correo"></td>
                <td v-text="data.celular"></td>
                <td>
                  <button
                    type="button"
                    class="btn btn-danger btn-sm"
                    @click="destroyCorreo(data.id)"
                    v-show="$store.getters.can('admin.empresas.eliminarCorreo')"
                  >
                    <i class="fas fa-trash-alt"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import vSelect from "vue-select";

export default {
  name: "EmpresaListaCorreo",
  components: {
    vSelect,
  },
  data() {
    return {
      form: {},
      cor: {
        eventos: [],
        correos: [],
        celular: null,
      },
      listasForms: {
        eventos_correos: [],
      },
      correos: {},
    };
  },
  computed: {
    formularioValido() {
      return this.cor.eventos.length > 0
        && this.cor.correos.length > 0
        && this.cor.correos.every(c => this.esEmailValido(c));
    },
    totalRegistros() {
      return this.cor.eventos.length * this.cor.correos.length;
    },
  },
  methods: {
    esEmailValido(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    },

    validarEmailTag(email) {
      if (!this.esEmailValido(email)) {
        this.$swal({
          icon: "error",
          title: `"${email}" no es un correo válido`,
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
        this.$nextTick(() => {
          this.cor.correos = this.cor.correos.filter(c => c !== email);
        });
      }
    },

    getEventosCorreos() {
      axios.get("/api/lista/4").then((response) => {
        this.listasForms.eventos_correos = response.data;
      });
    },

    getCorreos() {
      axios
        .get("/api/admin/listasCorreos", {
          params: {
            trans: this.$parent.form.id,
          },
        })
        .then((response) => {
          this.correos = response.data;
        });
    },

    guardar_correos() {
      if (!this.formularioValido) return;

      const data = {
        empresa_id: this.$parent.form.id,
        eventos: this.cor.eventos,
        correos: this.cor.correos,
        celular: this.cor.celular,
      };

      this.$parent.cargando = true;
      axios.post("/api/admin/listasCorreos", data)
        .then((response) => {
          const res = response.data;
          let mensaje = `Se crearon ${res.creados} registro(s) exitosamente.`;
          if (res.duplicados > 0) {
            mensaje += ` ${res.duplicados} ya existían y se omitieron.`;
          }
          this.cor = { eventos: [], correos: [], celular: null };
          this.$swal({
            icon: res.creados > 0 ? "success" : "info",
            title: mensaje,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
          });
          this.getCorreos();
          this.$parent.cargando = false;
        })
        .catch((e) => {
          this.$swal({
            icon: "error",
            title: "Ocurrió un error, vuelva a intentarlo..." + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.$parent.cargando = false;
        });
    },

    destroyCorreo(idListaCorreo) {
      this.$swal({
        title: "Esta seguro de eliminar este correo?",
        text: "Los cambios no se pueden revertir!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si, Eliminar!",
      }).then((result) => {
        if (result.value) {
          this.$parent.cargando = true;
          axios.delete("/api/admin/listasCorreos/" + idListaCorreo).then(() => {
            this.getCorreos();
            this.$swal({
              icon: "success",
              title: "Se eliminó el correo exitosamente...",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 4000,
              timerProgressBar: true,
            });
            this.$parent.cargando = false;
          });
        }
      });
    },
  },

  created() {
    this.getEventosCorreos();
    this.getCorreos();
  },
};
</script>
